import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import EmailModal from './EmailModal';

const EmailButton = ({ 
  recipientEmail = '', 
  recipientUid = null, 
  user = null, // Add user object to check subscription status
  className = '', 
  children = null,
  variant = 'default' // 'default', 'outline', 'ghost'
}) => {
  const [showEmailModal, setShowEmailModal] = useState(false);

  // Check if user is subscribed to emails
  const isUserSubscribed = user ? !user.emailUnsubscribed : true;

  const getButtonClasses = () => {
    const baseClasses = 'inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400';
    
    if (!isUserSubscribed) {
      return `${baseClasses} bg-gray-300 text-gray-500 cursor-not-allowed`;
    }
    
    switch (variant) {
      case 'outline':
        return `${baseClasses} border border-blue-500 text-blue-500 hover:bg-blue-50`;
      case 'ghost':
        return `${baseClasses} text-blue-500 hover:bg-blue-50`;
      default:
        return `${baseClasses} bg-blue-500 text-white hover:bg-blue-600`;
    }
  };

  return (
    <>
      <button
        onClick={() => isUserSubscribed && setShowEmailModal(true)}
        disabled={!isUserSubscribed}
        className={`${getButtonClasses()} ${className}`}
        title={isUserSubscribed ? "Send email to this user" : "User is unsubscribed from emails"}
      >
        <Mail className="w-4 h-4" />
      </button>

      {isUserSubscribed && (
        <EmailModal
          isOpen={showEmailModal}
          onClose={() => setShowEmailModal(false)}
          recipientEmail={recipientEmail}
          recipientUid={recipientUid}
        />
      )}
    </>
  );
};

export default EmailButton; 